export default __webpack_public_path__ + "static/media/clinica_content.f6ecbc96.jpg";